import { percentage } from '../formatters';
/**
 * Adds an onHover tooltip to bar charts:
 * For non-stacked graphs, stackedBarPrefix is empty and will only show value and unit:
 * i.e: 123,345 Followers
 * For stacked graphs (used in Social Benchmarking), prefix will be set by visualization type (Media Type/Platform):
 * i.e: 25,600 X Followers
 */

const ENGAGEMENT_RATE_LABEL = 'Engagement Rate (per 10k Followers)';

export const tooltipLabelCallback = (
    context,
    formatter,
    labelUnit = null,
    isStacked = false,
    isHorizontal = false,
    hasPercentage = false,
    percentageTotal = 0,
) => {
    const value = isHorizontal ? context.parsed.x : context.parsed.y;
    if (hasPercentage) {
        const unit = labelUnit !== null ? labelUnit : '';
        const perc = percentage(percentageTotal ? value / percentageTotal : 0);
        return `${formatter(value)} ${unit} (${perc})`;
    } else {
        let stackedBarPrefix = isStacked ? `${context.dataset.label} ` : '';
        let unit = labelUnit === 'Post Volume' ? 'Posts' : labelUnit;

        if (context.dataset.label === ENGAGEMENT_RATE_LABEL)
            unit = 'Engagements per 10K Followers';

        return `${formatter(value)} ${stackedBarPrefix}${unit}`;
    }
};
